import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import AppLayout from "./AppLayout"
import { Button } from "./ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs"
import { Calendar, Clock, LogIn, LogOut } from "lucide-react"
import authService from "../Services/authService";
import { parseISO, parse, format } from "date-fns";


const AttendanceScreen = () => {
  const [activeTab, setActiveTab] = useState("today")
  const [clockedIn, setClockedIn] = useState(false)
  const [clockInTime, setClockInTime] = useState(null)
  const [clockOutTime, setClockOutTime] = useState(null)
  const [attendanceHistory, setAttendanceHistory] = useState([]);

  useEffect(() => {
    loadAttendence();
  }, []);

  const loadAttendence = () => {
    const token = authService.getCurrentUsertoken();
    const url = new URL(authService.getApiUrl() + 'currentweekattendance');
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        user_id: authService.getCurrentuser().id,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.clientlogout();
          window.location.href = "/login";
        } else {
          return res.json();
        }
      })
      .then((result) => {
        const today = result.data.today;
        const week = result.data.week;

        setClockInTime(today.check_in && today.check_in !== "00:00:00" ? today.check_in : null);
        setClockOutTime(today.check_out && today.check_out !== "00:00:00" ? today.check_out : null);
        setAttendanceHistory({ week });
      })
      .catch((err) => {
        console.log(err.message);
      });
  };


  const handleClockIn = () => {
    const now = new Date()
    setClockInTime(format(now, "hh:mm a"))
    setClockedIn(true)

    const token = authService.getCurrentUsertoken();
    const url = new URL(authService.getApiUrl() + 'attendance');
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        user_id: authService.getCurrentuser().id,
        date: new Date(),
        check_in: format(now, "HH:mm:ss"),
        check_out: "",
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.clientlogout();
          window.location.href = "/login";
        } else {
          return res.json();
        }
      })
      .then((result) => {
        //loadAttendence();
      })
      .catch((err) => {
        console.log(err.message);
      });
    //alert(format(now, "hh:mm:ss"));
  }

  const handleClockOut = () => {
    const now = new Date()
    setClockOutTime(format(now, "hh:mm a"))
    setClockedIn(false)

    const token = authService.getCurrentUsertoken();
    const url = new URL(authService.getApiUrl() + 'attendance');
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        user_id: authService.getCurrentuser().id,
        date: new Date(),
        check_in: "",
        check_out: format(now, "HH:mm:ss"),
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.clientlogout();
          window.location.href = "/login";
        } else {
          return res.json();
        }
      })
      .then((result) => {
        //loadAttendence();
      })
      .catch((err) => {
        console.log(err.message);
      });
  }

  // Sample attendance history data
  // const attendanceHistory = [
  //   { date: "June 13, 2025", clockIn: "09:00 AM", clockOut: "06:00 PM", status: "Present", hours: "9h 0m" },
  //   { date: "June 12, 2025", clockIn: "09:15 AM", clockOut: "06:30 PM", status: "Present", hours: "9h 15m" },
  //   { date: "June 11, 2025", clockIn: "08:45 AM", clockOut: "05:45 PM", status: "Present", hours: "9h 0m" },
  //   { date: "June 10, 2025", clockIn: "-", clockOut: "-", status: "Leave", hours: "-" },
  //   { date: "June 09, 2025", clockIn: "09:30 AM", clockOut: "06:15 PM", status: "Present", hours: "8h 45m" },
  // ]

  // Sample leave balance data
  const leaveBalance = [
    { type: "Casual Leave", used: 3, total: 12, remaining: 9 },
    { type: "Sick Leave", used: 1, total: 7, remaining: 6 },
    { type: "Earned Leave", used: 0, total: 15, remaining: 15 },
  ]

  const formatTo12Hour = (timeStr) => {
    if (!timeStr || timeStr === "00:00:00") return "--:--";
    const parsed = parse(timeStr, "HH:mm:ss", new Date());
    return format(parsed, "hh:mm a");
  };


  const formatDate = (dateStr) => {
    if (!dateStr) return "--";
    const parsedDate = parseISO(dateStr);
    return format(parsedDate, "MMMM d, yyyy");
  };

  const formatDuration = (timeStr) => {
    if (!timeStr || timeStr === "00:00:00") return "--";
    const [hours, minutes] = timeStr.split(":");
    return `${parseInt(hours)}h ${parseInt(minutes)}m`;
  };

  return (
    <AppLayout>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center flex-1 min-w-0">
          <div className="relative h-[100px] w-[100px] mr-2 flex-shrink-0">
            <img src="/images/pranaam-365-logo.png" alt="Pranaam365 Logo" className="w-full h-full object-contain" />
          </div>
          <div className="min-w-0">
            <h1 className="text-xl font-bold text-gray-800 truncate">Attendance</h1>
            <p className="text-sm text-gray-500 truncate">Track your work hours</p>
          </div>
        </div>
      </div>

      <Card className="mb-4 border-gray-200">
        <CardHeader className="pb-2 px-4 pt-4">
          <CardTitle className="text-lg text-gray-800 text-left">Today's Status</CardTitle>
        </CardHeader>
        <CardContent className="px-4 pb-4">
          <div className="flex flex-col items-center">
            <div className="text-xl font-bold mb-2 text-gray-800">{format(new Date(), "EEEE")}</div>
            <div className="text-base text-gray-500 mb-4">{format(new Date(), "MMMM d, yyyy")}</div>

            <div className="grid grid-cols-2 gap-3 w-full mb-4">
              <div className="flex flex-col items-center p-3 bg-gray-50 rounded-lg">
                <span className="text-sm text-gray-500 mb-1">Clock In</span>
                <span className="text-base font-semibold text-gray-800">{clockInTime || "--:--"}</span>
              </div>
              <div className="flex flex-col items-center p-3 bg-gray-50 rounded-lg">
                <span className="text-sm text-gray-500 mb-1">Clock Out</span>
                <span className="text-base font-semibold text-gray-800">{clockOutTime || "--:--"}</span>
              </div>
            </div>

            {!clockInTime ? (
              <Button
                onClick={handleClockIn}
                className="w-full h-12 bg-pranaam-red hover:bg-red-700 text-white"
              >
                <LogIn className="mr-2 h-4 w-4" />
                Clock In
              </Button>
            ) : (
              <Button
                onClick={handleClockOut}
                className="w-full h-12 bg-pranaam-red hover:bg-red-700 text-white"
                disabled={!!clockOutTime} // Disable if already clocked out
              >
                <LogOut className="mr-2 h-4 w-4" />
                Clock Out
              </Button>
            )}

            {/* <div className="w-full mt-3">
              <Button variant="outline" className="w-full h-12 border-gray-200 text-gray-800 hover:bg-gray-50" asChild>
                <Link to="/attendance/leave">
                  <Calendar className="mr-2 h-4 w-4 text-pranaam-red" />
                  Apply for Leave
                </Link>
              </Button>
            </div>
            <div className="w-full mt-3">
              <Button variant="outline" className="w-full h-12 border-gray-200 text-gray-800 hover:bg-gray-50" asChild>
                <Link to="/attendance/leave">
                  <Calendar className="mr-2 h-4 w-4 text-pranaam-red" />
                 History
                </Link>
              </Button>
            </div> */}
            <div className="flex space-x-4 mt-3">
              <div className="w-1/2">
                <Button
                  variant="outline"
                  className="w-full h-12 border-gray-200 text-gray-800 hover:bg-gray-50"
                  asChild
                >
                  <Link to="/attendance/leave">
                    <Calendar className="mr-2 h-4 w-4 text-pranaam-red" />
                    Apply for Leave
                  </Link>
                </Button>
              </div>
              <div className="w-1/2">
                <Button
                  variant="outline"
                  className="w-full h-12 border-gray-200 text-gray-800 hover:bg-gray-50"
                  asChild
                >
                  <Link to="/attendance/history">
                    <Calendar className="mr-2 h-4 w-4 text-pranaam-red" />
                    Attendance History
                  </Link>
                </Button>
              </div>
            </div>


          </div>
        </CardContent>
      </Card>

      <Tabs defaultValue="history" className="mb-6" onValueChange={setActiveTab}>
        {/* <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="history" className="data-[state=active]:bg-pranaam-red data-[state=active]:text-white">
            Attendance History
          </TabsTrigger>
          <TabsTrigger value="leave" className="data-[state=active]:bg-pranaam-red data-[state=active]:text-white">
            Leave Balance
          </TabsTrigger>
        </TabsList> */}

        <TabsContent value="history" className="mt-4">
          <Card className="border-gray-200">
            <CardContent className="p-0">
              <div className="divide-y divide-gray-200">
                {attendanceHistory.week?.map((day, index) => (
                  <div key={index} className="p-3">
                    <div className="flex justify-between items-center mb-1">
                      <span className="font-medium text-gray-800 text-sm">
                        {formatDate(day.date)}
                      </span>
                      <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${day.status === "Present" ? "bg-green-100 text-green-800" :
                        day.status === "Leave" ? "bg-amber-100 text-amber-800" : "bg-gray-100 text-gray-600"
                        }`}>
                        {day.status || "N/A"}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm text-gray-500">
                      {day.status !== "Leave" ? (
                        <span className="flex items-center">
                          <Clock className="inline-block h-3 w-3 mr-1" />
                         {formatTo12Hour(day.check_in)} - {formatTo12Hour(day.check_out)}
                        </span>
                      ) : (
                        <span> Status : {day.leave_status}</span>
                      )}


                      <span>{formatDuration(day.total_working_hours)}</span>
                    </div>
                  </div>
                ))}

              </div>
            </CardContent>
          </Card>
        </TabsContent>

        {/* <TabsContent value="leave" className="mt-4">
          <Card className="border-gray-200">
            <CardContent className="p-0">
              <div className="divide-y divide-gray-200">
                {leaveBalance.map((leave, index) => (
                  <div key={index} className="p-4">
                    <div className="flex justify-between items-center">
                      <span className="font-medium text-gray-800">{leave.type}</span>
                      <span className="text-sm font-medium text-gray-800">{leave.remaining} days</span>
                    </div>
                    <div className="mt-1 h-2 w-full bg-gray-200 rounded-full overflow-hidden">
                      <div
                        className="h-full bg-pranaam-red"
                        style={{ width: `${(leave.used / leave.total) * 100}%` }}
                      ></div>
                    </div>
                    <div className="flex justify-between text-xs text-gray-500 mt-1">
                      <span>Used: {leave.used} days</span>
                      <span>Total: {leave.total} days</span>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent> */}
      </Tabs>
    </AppLayout>
  )
}

export default AttendanceScreen
